import { useState } from "react";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

const CONFIRMATION_TEXT = "drop all documents";

interface DropAllDocsConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isDeleting: boolean;
  onConfirm: () => void;
}

export function DropAllDocsConfirmDialog({
  open,
  onOpenChange,
  isDeleting,
  onConfirm,
}: DropAllDocsConfirmDialogProps) {
  const [confirmationInput, setConfirmationInput] = useState("");

  const isConfirmEnabled =
    confirmationInput.toLowerCase() === CONFIRMATION_TEXT;

  const handleOpenChange = (newOpen: boolean) => {
    if (!newOpen) {
      setConfirmationInput("");
    }
    onOpenChange(newOpen);
  };

  return (
    <AlertDialog open={open} onOpenChange={handleOpenChange}>
      <AlertDialogContent onClick={(e) => e.stopPropagation()}>
        <AlertDialogHeader>
          <AlertDialogTitle>Drop all documents?</AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <span className="block">
              This action will permanently delete all documents associated with
              this procedure. This cannot be undone.
            </span>
            <span className="block font-medium text-red-600">
              All uploaded documents and their extractions will be removed.
            </span>
          </AlertDialogDescription>
        </AlertDialogHeader>

        <div className="py-4">
          <Label htmlFor="confirmation-input" className="text-sm font-medium">
            Type "{CONFIRMATION_TEXT}" to confirm
          </Label>
          <Input
            id="confirmation-input"
            value={confirmationInput}
            onChange={(e) => setConfirmationInput(e.target.value)}
            placeholder={CONFIRMATION_TEXT}
            className="mt-2"
            disabled={isDeleting}
            autoComplete="off"
          />
        </div>

        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
          <Button
            variant="destructive"
            onClick={onConfirm}
            loading={isDeleting}
            disabled={!isConfirmEnabled || isDeleting}
            className="bg-red-600 hover:bg-red-700"
          >
            Drop All Documents
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
